import { Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { PermissionUtils } from 'utils'
import homeRoutes from 'modules/Home/routing/routes'
import EventCreatorRouting, {
  routes as eventCreatorRoutes,
} from 'modules/virtualClassrooms/manager/EventCreator/routing'
import EventDetailsRouting, {
  routes as eventDetailsRoutes,
} from 'modules/virtualClassrooms/manager/EventDetails/routing'
import EventListRouting, {
  routes as eventListRoutes,
} from 'modules/virtualClassrooms/manager/EventList/routing'
import SchedulesRouting, {
  routes as schedulesRoutes,
} from 'modules/virtualClassrooms/manager/Schedules/routing'
import routes from './managerRoutes'

const { RouteChangeProgress } = common

export { routes }

const ManagerRouting = () => {
  const virtualClassroomDenied = PermissionUtils.virtualClassroomDenied()
  const virtualClassroomManageEventsDenied = PermissionUtils.virtualClassroomManageEventsDenied()

  return (
    <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
      <Switch>
        <PrivateRoute
          path={eventCreatorRoutes.root}
          component={EventCreatorRouting}
          disabled={virtualClassroomDenied || virtualClassroomManageEventsDenied}
        />
        <PrivateRoute
          path={eventListRoutes.root}
          component={EventListRouting}
          disabled={virtualClassroomDenied}
        />
        <PrivateRoute
          path={schedulesRoutes.root}
          component={SchedulesRouting}
          disabled={virtualClassroomDenied}
        />
        <PrivateRoute
          path={eventDetailsRoutes.root}
          component={EventDetailsRouting}
          disabled={virtualClassroomDenied}
        />
        <Redirect path='*' to={homeRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default ManagerRouting
